import { ViewModel,View, ObservableArray } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { downloadFile, getAsNumber } from "src/uicomponents/components/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { FileSelectorViewModel, PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WarehouseOptimalTransferView } from "./warehouseOptimalTransfer-view";
import moment from "moment";

export class WarehouseOptimalTransferViewModel extends WindowViewModel implements IPopup{
    public getTitle(): string {
        return 'تنظیم بهینه انتقال';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.warehouseOptimalTransferAmounts = ObservableArray.create<SingleOptimalTransfer>();
        this.loader = new ServerSideDataLoader(x=>this.refreshPaged(x));
        this.refresh();
        this.fileSelector = new FileSelectorViewModel(this);
    }
    GetDefaultView(): View <ViewModel> {
        return new WarehouseOptimalTransferView();
    }
    public getTypeId(): string {
        return "VM-856B7CC8-066B-405D-AA5B-CDCD3D4EF447"
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set warehouseOptimalTransferAmounts(v: ObservableArray<SingleOptimalTransfer>) { this._warehouseOptimalTransferAmounts = v; } public get warehouseOptimalTransferAmounts(): ObservableArray<SingleOptimalTransfer> { return this._warehouseOptimalTransferAmounts;} private _warehouseOptimalTransferAmounts: ObservableArray<SingleOptimalTransfer>;
    public set fileSelector(v: FileSelectorViewModel) { this._fileSelector = v; } public get fileSelector(): FileSelectorViewModel { return this._fileSelector;} private _fileSelector: FileSelectorViewModel;

    async refresh(){
        this.loader.refresh();
    }
    closePopup() {}
    
    async refreshPaged(filteringInformation:any):Promise<PaginationInfo>{
        try {
            let verificationResult =  this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'خطا');
                throw verificationResult;
            }
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseTransferServices/GetAllWarehouseOptimalTransfers',{
                FurtherQueryInfo :filteringInformation,
            });
            this.warehouseOptimalTransferAmounts.update(...result.Products.map((x,i)=>{
                let r = new SingleOptimalTransfer(this);
                r.rowNumber = i + 1;
                r.productCode = x.ProductCode;
                r.productId = x.ProductId;
                r.measuredProductId = x.MeasuredProductId;
                r.productName = x.ProductName;
                r.productCarModel = x.ProductCarModel;
                r.productBrand = x.ProductBrand;
                r.balance = x.OptimalTransferAmount;
                r.balanceMargin = x.BalanceMargin;
                r.optimalTransferLastUpdate = x.OptimalTransferLastUpdate != null ? moment.utc(x.OptimalTransferLastUpdate) : null;
                r.balanceMarginLastUpdate = x.BalanceMarginLastUpdate != null ? moment.utc(x.BalanceMarginLastUpdate) : null;
                r.updated = false;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }

    async save(item:SingleOptimalTransfer){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseTransferServices/SetWarehouseOptimalTransfer',{
                MeasuredProductId:item.measuredProductId,
                BalanceMargin:item.balanceMargin,
                OptimalTransferAmount : item.balance
            });
            if(result.IsSuccessful){
                await this.messageBoxConfirmSuccess('بهینه انبار با موفقیت بروزسانی شد.','عملیات موفق');
                this.refresh();
            }else{
                await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            }
            return result;
        } catch (ex) {
                await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            throw ex;
        } finally {
            this.isLoading = false;
        }
    }

    verify():string[] {
        let errors :string[]= [];
        return errors;
    }

    async export(){
        try {
            let verificationResult =  this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'خطا');
                return;
            }
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseTransferServices/ExportWarehouseOptimalTransfers',{
            });
            downloadFile(result.ExcelFile, `Export_Optimal_Transfer_Amount.xlsx`);
            return result;
        } catch (ex) {
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async import(){
        try {
            let errors :string[]= [];
            if(!this.fileSelector?.isFileChoosed()){
                errors.push('فایلی انتخاب نشده است.');
            }
            let validationResult = errors.join("\n");
            if(validationResult != ""){
                await this.messageBoxConfirmWarning(validationResult,"خطا");
                return ;
            }
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseTransferServices/ImportWarehouseOptimalTransfers',{
                ExcelFile : this.fileSelector.filecontent
            });
            let popup = new Verification(this);
            popup.warehouseOptimalTransferAmounts.update(...result.Products.map((x,i)=>{
                let r = new SingleOptimalTransfer(this);
                r.rowNumber = i+1;
                r.productCode = x.ProductCode;
                r.measuredProductId = x.MeasuredProductId;
                r.balance = x.WarehouseOptimalTransferAmount;
                r.balanceMargin = x.BalanceMargin;
                r.isFound = x.IsFound;
                return r;
            }));
            this.showPopup(popup);
        } catch (ex) {
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    
    async acceptImport(optimalTransfersAmount: ObservableArray<SingleOptimalTransfer>){
        try {
            this.isLoading = true;
            let optimalTransferAmounts = optimalTransfersAmount.filter(x => x.isFound);
            let result = await ServerConnection.callServer('/Complex/WarehouseTransferServices/SetBatchWarehouseOptimalTransfers',{
                Products : optimalTransferAmounts.map(x => {
                    return {
                        MeasuredProductId : x.measuredProductId,
                        IsFound : x.isFound,
                        BalanceMargin : x.balanceMargin,
                        WarehouseOptimalTransferAmount : x.balance
                    }
                })
            });
            await this.messageBoxConfirmSuccess('بهینه موجودی انبارها با موفقیت بروزسانی شد.','عملیات موفق');
            this.refresh();
            return result;
        } catch (ex) {
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

}

export class Verification extends ViewModel implements IPopup{
    public getTypeId(): string {return 'verification';}
    public GetDefaultView(): View<ViewModel> {return null;}
    closePopup() {}
    constructor(parent:WarehouseOptimalTransferViewModel) {
        super(parent);
        this._parent = parent;
        this.warehouseOptimalTransferAmounts = ObservableArray.create<SingleOptimalTransfer>();
    }

    public set warehouseOptimalTransferAmounts(v: ObservableArray<SingleOptimalTransfer>) { this._warehouseOptimalTransferAmounts = v; } public get warehouseOptimalTransferAmounts(): ObservableArray<SingleOptimalTransfer> { return this._warehouseOptimalTransferAmounts;} private _warehouseOptimalTransferAmounts: ObservableArray<SingleOptimalTransfer>;
    
    private _parent : WarehouseOptimalTransferViewModel;

    async accept(){
        this._parent.acceptImport(this.warehouseOptimalTransferAmounts);
        this.closePopup();
    }
}

export class SingleOptimalTransfer extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<WarehouseOptimalTransferViewModel> {return null;}
    constructor(parent:WarehouseOptimalTransferViewModel) {
        super(parent);
        this._typedParent = parent;
    }
    private _typedParent : WarehouseOptimalTransferViewModel;
    
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set productId(v: string) { this._productId = v; } public get productId(): string { return this._productId;} private _productId: string;
    public set measuredProductId(v: string) { this._measuredProductId = v; } public get measuredProductId(): string { return this._measuredProductId;} private _measuredProductId: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName;} private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode;} private _productCode: string;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel;} private _productCarModel: string;
    public set productBrand(v: string) { this._productBrand = v; } public get productBrand(): string { return this._productBrand;} private _productBrand: string;
    public set balance(v: number) { 
        this._balance = v; 
        this.updateParentChangeStatus();
    } public get balance(): number { return this._balance;} private _balance: number;
    public set balanceMargin(v: number) { 
        this._balanceMargin = v; 
        this.updateParentChangeStatus();
    } public get balanceMargin(): number { return this._balanceMargin;} private _balanceMargin: number;
    public set optimalTransferLastUpdate(v: moment.Moment) { this._optimalTransferLastUpdate = v; } public get optimalTransferLastUpdate(): moment.Moment { return this._optimalTransferLastUpdate;} private _optimalTransferLastUpdate: moment.Moment;
    public set balanceMarginLastUpdate(v: moment.Moment) { this._balanceMarginLastUpdate = v; } public get balanceMarginLastUpdate(): moment.Moment { return this._balanceMarginLastUpdate;} private _balanceMarginLastUpdate: moment.Moment;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isDone(v: boolean) { this._isDone = v; } public get isDone(): boolean { return this._isDone;} private _isDone: boolean;
    public set isFailed(v: boolean) { this._isFailed = v; } public get isFailed(): boolean { return this._isFailed;} private _isFailed: boolean;
    public set isFound(v: boolean) { this._isFound = v; } public get isFound(): boolean { return this._isFound;} private _isFound: boolean;
    public set updated(v: boolean) { this._updated = v; } public get updated(): boolean { return this._updated;} private _updated: boolean;
    
    verify():string[]{
        let result :string[] =[];
        if (this.balance < 0) 
            result.push('مقدار بهینه نامعتبر است.');
        if (this.balanceMargin < 0) 
            result.push('رزرو بهینه نامعتبر است.');
        return result;
    }

    setNull() {
        this.balance = null;
        this.balanceMargin = null;
    }

    updateParentChangeStatus(){
        this.updated = true;
        this.isDone = false;
        this.isFailed = false;
    }

    async confirm(){
        try {
            this.isLoading = true;
            let verificationResult =  this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت مقدار بهینه');
                return;
            }
            this.isDone = false;
            this.isFailed = false;
            let result = await this._typedParent.save(this);
            if(result.IsSuccessful){
                this.isDone = true;
                this.updated = false;
            }else{
                this.isFailed = true;
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
}
